export default __webpack_public_path__ + "static/certificate-pet-square-e0b92dd405c49d73bdc4f5391d90c240.png";